<router-outlet></router-outlet>

<ng-container #modal></ng-container>

<app-scroll-top-button></app-scroll-top-button>
